import * as React from 'react';

import {Button} from 'shells/button/button';
import {Stack} from 'shells/layout/stack/stack';
import {MARKETING_AUTOMATIONS_TOUR_ADD_PAGE_ID} from 'shells/tours/tours';
import {useNutshellTour} from 'shells/tours/use-nutshell-tour';

import {PageContainer, PageTitleBar} from '../../layout';

import {AnalyticsStatusButton} from '../analytics/report/analytics-status/analytics-status-button';

import {CreateMoneyPageModal} from './create-money-page-modal';
import {useGetMoneyPages, GET_MONEY_PAGES_LIMIT} from './graphql/hooks/use-get-money-pages';
import {MoneyPagesTable} from './money-pages-table';

export function MoneyPagesListPage() {
    const [isCreateModalOpen, setIsCreateModalOpen] = React.useState(false);

    const {moneyPages, isLoading, fetchNextPage, fetchPreviousPage, totalCount} =
        useGetMoneyPages();
    const {startTour, progressTour, pauseTour, exitTour} = useNutshellTour();

    return (
        <PageContainer
            title='Marketing automations'
            pageTitleBar={
                <PageTitleBar
                    title='Marketing automations'
                    subheaderPrimaryText='Configure automations that trigger when leads visit specific pages on your website'
                    buttons={
                        <Stack isHorizontal={true} spacing={8}>
                            <AnalyticsStatusButton pageType='analytics' />
                            <Button
                                variant='primary'
                                size='big'
                                onClick={() => setIsCreateModalOpen(true)}
                                id={MARKETING_AUTOMATIONS_TOUR_ADD_PAGE_ID}
                            >
                                Add new automation
                            </Button>
                        </Stack>
                    }
                />
            }
            noPadding={true}
        >
            <MoneyPagesTable
                moneyPages={moneyPages}
                fetchNextPage={fetchNextPage}
                fetchPreviousPage={fetchPreviousPage}
                isLoading={isLoading}
                pageSize={GET_MONEY_PAGES_LIMIT}
                totalCount={totalCount}
                onPrimaryCtaClick={() => {
                    setIsCreateModalOpen(true);
                }}
                onSecondaryCtaClick={() => {
                    startTour('marketing-automations-tour');
                }}
            />
            <CreateMoneyPageModal
                isOpen={isCreateModalOpen}
                onClose={() => setIsCreateModalOpen(false)}
                progressTour={progressTour}
                pauseTour={pauseTour}
                exitTour={exitTour}
            />
        </PageContainer>
    );
}
